import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=032e9668&scoped=true&"
import script from "./Fourth.vue?vue&type=script&lang=js&"
export * from "./Fourth.vue?vue&type=script&lang=js&"
import style0 from "./Fourth.vue?vue&type=style&index=0&id=032e9668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e9668",
  null
  
)

export default component.exports